/* global axios */
import ApiClient from './ApiClient';

class FlowsAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  clone(id) {
    return axios.post(`${this.url}/${id}/clone`);
  }

  activate(id) {
    return axios.post(`${this.url}/${id}/activate`);
  }

  deactivate(id) {
    return axios.post(`${this.url}/${id}/deactivate`);
  }

  getExecutions(id, params = {}) {
    return axios.get(`${this.url}/${id}/executions`, { params });
  }

  getExecutionSteps(id, executionId) {
    return axios.get(`${this.url}/${id}/executions/${executionId}/steps`);
  }
}

export default new FlowsAPI();
